<template>
    <div>
        <div class="row justify-center">
            <q-select
                path="phone_prefix"
                auto-select
                v-model="phone_prefix"
                :float-label="$T('phone prefix')"
                :options="phonePrefixes"
                class="col-3"
                style="margin-right: 20px;"
            >
            </q-select>

            <q-input
                path="phone"
                v-model="phone"
                :label="$T('cell phone')"
                :float-label="$T('cell phone')"
                class="col-3"
                style="margin-right: 20px;"
            >
            </q-input>

            <v-button
                outline
                :disabled="can_send"
                :loading="loading"
                :label="$T('Validate')"
                @click.native.prevent="validate"
                icon="save"
                color="highlight"
                class="no-shadow uppercase q-btn-iqos"
            >
            </v-button>
        </div>

        <q-dialog v-model="show_dialog" prevent-close>
            <span slot="title">{{ $T('Validate SMS code') }}</span>

            <div slot="body">
                <q-field :helper="$T('We sent an SMS with a three digits code')"
                         :error="codeHasError"
                         :error-label="$T('Invalid code')">
                    <q-input
                        path="code"
                        v-model="code"
                        :label="$T('code')"
                        :float-label="$T('code')"
                        class="col-4"
                    />
                </q-field>
            </div>

            <template slot="buttons" class="text-center">
                <v-button
                    class="no-shadow uppercase q-btn-iqos"
                    outline
                    color="grey"
                    @click.native.prevent="cancel"
                    :label="$T('cancel')">
                </v-button>
                <v-button
                    class="no-shadow uppercase q-btn-iqos"
                    outline
                    :disabled="codeLength < 3"
                    :loading="loading"
                    color="highlight"
                    icon="send"
                    @click.native.prevent="validateCode"
                    :label="$T('send')">
                </v-button>
                <v-button
                    class="no-shadow uppercase q-btn-iqos"
                    outline
                    :disabled="loading"
                    :loading="loading"
                    color="highlight"
                    icon="resend"
                    @click.native.prevent="resend"
                    :label="$T('Resend')">
                </v-button>
            </template>
        </q-dialog>
    </div>
</template>

<script>
import phonePrefixes from "../../../../helpers/phonePrefix"
import VButton from "../../../../components/form/VButton"
import axios from "axios"
import {QDialog, QCard, QCardActions} from "quasar-framework"
import {EventBus} from '../../../../plugins/event-bus'

export default {
    name: "phoneValidation",
    components: {VButton, QDialog, QCard, QCardActions},
    mixins: [phonePrefixes],

    data() {
        return {
            codeHasError: false,
            numberPattern: /\d+/g,
            loading: false,
            show_dialog: false,
            phone_prefix: "0034",
            phone: "",
            code: "",
            token: "",
        };
    },
    methods: {
        validate() {
            this.loading = true;
            axios.get(`${config.appUrl}/api/v1/lending-point/validate-phone`, {
                params:
                    {
                        phone_prefix: this.phone_prefix,
                        phone: this.phone.match(this.numberPattern).join('')
                    }
            })
                .then(response => {
                    if (response.data.status) {
                        this.show_dialog = true;
                        this.token = response.data.token
                    }
                    else {
                        this.notify(this.$T('error'), response.data.message, [], 'negative')
                    }
                    this.loading = false;
                })
                .catch(response => {
                    console.log(response)
                })
        },
        resend() {
            this.loading = true
            axios.get(`${config.appUrl}/api/v1/lending-point/validate-phone`, {
                params:
                    {
                        phone_prefix: this.phone_prefix,
                        phone: this.phone.match(this.numberPattern).join('')
                    }
            })
                .then(response => {
                    if (response.data.status) {
                        this.show_dialog = true;
                        this.token = response.data.token
                    }
                    else {
                        this.notify(this.$T('error'), response.data.message, [], 'negative')
                    }
                    this.loading = false;
                })
                .catch(response => {
                    console.log(response)
                })
        },
        cancel() {
            this.code = ''
            this.phone = ''
            this.phone_prefix = '0034'
            this.show_dialog = false
        },

        notify(message, detail, actions = [], type = 'positive') {
            this.$q.notify({
                type,
                position: 'top',
                message,
                detail,
                timeout: 5000,
                actions
            })
        },

        validateCode() {
            axios.get(`/api/v1/lending-point/compare/${this.code}/${this.token}/`)
                .then(response => {
                    if (response.data.status) EventBus.$emit('nextStep', this.phone, this.phone_prefix)
                    else {
                        this.notify(this.$T('error'), response.data.message, [], 'negative')
                    }
                })
        }
    },
    computed: {
        can_send() {
            return this.phone.length < 8 || this.loading
        },
        codeLength() {
            return this.code.length
        }
    },
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// resources/assets/js/markets/CI/pages/lending-point/phoneValidation.vue